import { formatStreet } from "../../common/common.helpers";
import { UniversalConstructorContainer, UniversalConstructorMaterials } from "../universalConstructor.interfaces";

export default function modifyEpicOrders(data: UniversalConstructorContainer, materials: UniversalConstructorMaterials) {

  // add any errors and throw them with this
  let errMsg = ''

  /**
   * OPERATION 1: SHIPPING STREET IS A COMPOSITE OF TWO FIELDS
   */
  for (const order of data.ordersSuccessful) {
    order.missionControlOrder.order.ShippingStreet = formatStreet(order.original?.[0]?.['ShipToAddress1'], order.original?.[0]?.['ShipToAddress2'])
  }

  /**
   * OPERATION 2: SET COUNTRY (EPIC DOESN'T INCLUDE A COLUMN FOR THIS YET)
   */
  for (const order of data.ordersSuccessful) {
    order.missionControlOrder.order.ShippingCountry = 'US'
  }
  
  return data

}